import { useUserDetailsStore } from '@/stores/useUserDetails';
import { storeToRefs } from 'pinia';

export function useCustomerSupportInformation() {

  const userDetailsStore = useUserDetailsStore();
  const { amName, amEmail } = storeToRefs(userDetailsStore);

  const supportNumbers = [
    {
      name: 'Dispatch Support:',
      phoneNumber: '(716) 200-1362',
      rawPhoneNumber: '7162001362',
      email: 'transport@acvauctions.com',
      businessHours: '8am-8pm M-F, 8am - 5pm Sat EST'
    },
    {
      name: 'Carrier Support:',
      phoneNumber: '(716) 235-1774',
      rawPhoneNumber: '7162351774',
      email: 'carriers@acvauctions.com',
      businessHours: '8am-5pm M-F EST',
      amName: amName.value || '',
      amEmail: amEmail.value || ''
    },
    {
      name: 'Carrier Payments Support',
      phoneNumber: '(716) 313-2740',
      rawPhoneNumber: '7163132740',
      email: 'transportpayments@acvauctions.com',
      businessHours: '8am-5pm M-F EST'

    },
  ]

  return supportNumbers;
}
